import api from './api';

export const getCheckInData = async (barberShop: Number) => {
  return await api.get('check-in/' + barberShop.toString());
};
